// withDefaultErrorBoundary.tsx
import * as React from 'react'
import { withErrorBoundary } from './withErrorBoundary'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'

/**
 * HOC that automatically injects the default ErrorFallback.
 * No options required.
 */
export function withDefaultErrorBoundary<P>(Wrapped: React.ComponentType<P>) {
  return withErrorBoundary(Wrapped, {
    fallback: ({ error, reset }) => (
      <ErrorFallback error={error} onRetry={reset} />
    ),
  })
}
